import { createContext, useState } from 'react'

interface IUseWorkAccidentOccurrence {
  idOcorrenciaSelecionado: number
  setIdOcorrenciaSelecionado: React.Dispatch<React.SetStateAction<number>>
}

export const WorkAccidentOccurrenceContext = createContext<IUseWorkAccidentOccurrence>(null)

export const WorkAccidentOccurrenceProvider: React.FC = ({ children }) => {
  const [idOcorrenciaSelecionado, setIdOcorrenciaSelecionado] = useState<number>(0)

  return (
    <WorkAccidentOccurrenceContext.Provider
      value={{
        idOcorrenciaSelecionado,
        setIdOcorrenciaSelecionado,
      }}
    >
      {children}
    </WorkAccidentOccurrenceContext.Provider>
  )
}
